import { CompaniesWithoutKeyContactsResultConstants } from "../constants/CompaniesWithoutKeyContactsResultConstants";

/**
 * region for hepers*/

const initialState = {
  pending: false,
  ListResult: {},
}; 

export default function CompaniesWithoutKeyContactsResultReducers(state = initialState, action) {
  switch (action.type) {
    case CompaniesWithoutKeyContactsResultConstants.FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_PENDING:
      return {
        ...state,
        pending: true,
      };
    case CompaniesWithoutKeyContactsResultConstants.FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_RESULT_ERROR:
      return {
        ...state,
        error: action.error,
        pending: false,
      };
    case CompaniesWithoutKeyContactsResultConstants.FETCH_COMPANIES_WITHOUT_KEY_CONTACTS_RESULTS_GET_LIST_SUCCESS:
      return {
        ...state,
        pending: false,
        ListResult: action.payload, 
      };
    default:
      return state;
  }
}
